module.exports = require("rxjs/operators");